<template>
    <div class="border bg-white rounded-lg w-full p-4 shadow-sm max-w-4xl">
        <p class="text-gray-700 mb-4">{{ name }}</p>
        <slot @input="(val) => $emit('input', val)" :value="value" />
    </div>
</template>

<script>
export default {
    name: "input-wrapper",
    props: {
        name: String,
    },
};
</script>